import thunk from 'redux-thunk';
import {createStore, applyMiddleware, compose} from 'redux';
import { createBrowserHistory } from 'history';
import rootReducer from './reducers';

export const history = createBrowserHistory();

/* eslint-disable-next-line prefer-const */
let middlewareList = [thunk];

const middleWare = applyMiddleware(...middlewareList);

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, /* preloadedState, */ composeEnhancers(middleWare));

export default store;
